import darkLogo from '../assets/nifco_logo_dark.png';
import lightLogo from '../assets/nifco_logo_light.png';

export default {
  CONSTANTS: {
    redShift: '#ff817b',
    greenShift: '#8be28b',
    blueShift: '#779ecb',
    orangeColor: '#EE7500',
    lightOrange: '#EE9000',
    blueColor: '#3D7BFF',
    lightBlue: '#3db8ff',
    greenColor: '#28A746',
    lightGreen: '#34d95b',
    redColor: '#DC3445',
    yellowColor: '#F9C10A',
    lightYellow: '#F9D55E',
    disabledOrangeColor: '#F4A971',
    midGray: '#707070',
    lightGray: '#909090',
    white: '#F8F9FA',
    black: '#181818',
  },
  DARK: {
    bgColor: '#181818',
    fgColor: '#F8F9FA',
    textInputColor: '#363636',
    placeholderColor: '#909090',
    logo: darkLogo,
    statusBar: 'light-content',
  },
  LIGHT: {
    bgColor: '#F8F9FA',
    fgColor: '#181818',
    textInputColor: '#e3e3e3',
    placeholderColor: '#909090',
    logo: lightLogo,
    statusBar: 'dark-content',
  },
};